"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.BodySchema = exports.method = exports.path = void 0;
exports.parseBody = parseBody;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../../../common");
const lingo2_models_1 = require("lingo2-models");
// Здесь указываем path относительно основного роута
// например `${config.http.webUrl}` `${config.http.panelUrl}` `${config.http.backUrl}`
/** Относительно `${config.http.*}` */
exports.path = 'profile/1/profile';
exports.method = common_1.HttpMethod.PUT;
// #region Request
// Тело запроса. Optional
exports.BodySchema = zod_1.z.object({
  about: zod_1.z.string().optional().nullable(),
  birth_date: zod_1.z.string().datetime().optional().nullable().transform(v => v === '' ? null : v),
  spoken_languages: zod_1.z.array(common_1.SpokenLanguageSchema).optional().nullable(),
  studying_subjects: zod_1.z.array(common_1.StudyingSubject).optional().nullable(),
  education_schools: zod_1.z.array(common_1.EducationSchoolSchema).optional().nullable(),
  education_docs: zod_1.z.array(zod_1.z.string().uuid()).optional().nullable(),
  teaching_subjects: zod_1.z.array(common_1.TeachingSubjectSchema).optional().nullable(),
  social_accounts: zod_1.z.array(common_1.SocialAccountSchema).optional().nullable(),
  work_experience: zod_1.z.array(common_1.WorkExperienceSchema).optional().nullable(),
  // version: z.number().optional(),
  skype: zod_1.z.string().optional().nullable(),
  telegram: zod_1.z.string().optional().nullable()
});
function parseBody(values) {
  return exports.BodySchema.parse(values);
}
// Параметры запроса. Optional
// export const ParamsSchema = z.object({});
// export type Params = z.infer<typeof ParamsSchema>;
// export function parseParams(values: Params) {
//   return ParamsSchema.parse(values);
// }
// Query параметры запроса. Optional
// export const QuerySchema = z.object({});
// export type Query = z.infer<typeof QuerySchema>;
// export function parseQuery(values: Query) {
//   return QuerySchema.parse(values);
// }
// #endregion
// #region Response
exports.ResponseSchema = zod_1.z.object({
  data: zod_1.z.object({
    about: zod_1.z.string(),
    birth_date: zod_1.z.string().datetime(),
    spoken_languages: zod_1.z.array(common_1.SpokenLanguageSchema),
    studying_subjects: zod_1.z.array(common_1.StudyingSubject),
    education_schools: zod_1.z.array(common_1.EducationSchoolSchema),
    education_docs: zod_1.z.array(zod_1.z.string().uuid()),
    teaching_subjects: zod_1.z.array(common_1.TeachingSubjectSchema),
    social_accounts: zod_1.z.array(common_1.SocialAccountSchema),
    work_experience: zod_1.z.array(common_1.WorkExperienceSchema),
    version: zod_1.z.number(),
    verification_status: zod_1.z.nativeEnum(lingo2_models_1.UserProfileVerificationEnum),
    verification_comment: zod_1.z.string().optional(),
    verification_sent_at: zod_1.z.string().datetime(),
    verified_at: zod_1.z.string().datetime().optional(),
    skype: zod_1.z.string().optional(),
    telegram: zod_1.z.string().optional()
  })
});
function parseResponse(values) {
  return exports.ResponseSchema.parse(values);
}
// #endregion
